"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InformationWrapper = exports.InformationBox = exports.EventContent = exports.Div = exports.CalendarEventBtn = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _react2 = require("motion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CalendarEventBtn = exports.CalendarEventBtn = /*#__PURE__*/(0, _base.default)("button", process.env.NODE_ENV === "production" ? {
  target: "emupss04"
} : {
  target: "emupss04",
  label: "CalendarEventBtn"
})(props => /*#__PURE__*/(0, _react.css)("width:90%;border:none;border-radius:4px;background-color:", props.background, ";font-weight:600;cursor:pointer;text-align:left;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:CalendarEventBtn;")));
const InformationWrapper = exports.InformationWrapper = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "emupss03"
} : {
  target: "emupss03",
  label: "InformationWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1xdkr60",
  styles: "display:block;position:relative;font-weight:400"
} : {
  name: "1xdkr60",
  styles: "display:block;position:relative;font-weight:400",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const InformationBox = exports.InformationBox = /*#__PURE__*/(0, _base.default)(_react2.motion.div, process.env.NODE_ENV === "production" ? {
  target: "emupss02"
} : {
  target: "emupss02",
  label: "InformationBox"
})(process.env.NODE_ENV === "production" ? {
  name: "1nkktzb",
  styles: "position:absolute;width:22vw;text-align:center;border-radius:10px;background-color:white;z-index:1;top:-20px;left:calc(100% + 10px);box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.2);&::after{content:'';position:absolute;border-width:12px;border-style:solid;top:20px;right:100%;margin-left:-5px;border-color:transparent white transparent transparent;}"
} : {
  name: "1nkktzb",
  styles: "position:absolute;width:22vw;text-align:center;border-radius:10px;background-color:white;z-index:1;top:-20px;left:calc(100% + 10px);box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.2);&::after{content:'';position:absolute;border-width:12px;border-style:solid;top:20px;right:100%;margin-left:-5px;border-color:transparent white transparent transparent;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const EventContent = exports.EventContent = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "emupss01"
} : {
  target: "emupss01",
  label: "EventContent"
})(process.env.NODE_ENV === "production" ? {
  name: "gi73bv",
  styles: "display:grid;grid-template-columns:1fr;grid-row-gap:0.5em;justify-items:start;padding:1em"
} : {
  name: "gi73bv",
  styles: "display:grid;grid-template-columns:1fr;grid-row-gap:0.5em;justify-items:start;padding:1em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Div = exports.Div = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "emupss00"
} : {
  target: "emupss00",
  label: "Div"
})(process.env.NODE_ENV === "production" ? {
  name: "1deiktd",
  styles: "display:flex;justify-content:space-between;width:95%"
} : {
  name: "1deiktd",
  styles: "display:flex;justify-content:space-between;width:95%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});